import * as React from 'react';

function PlusIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 3.75C13 3.33579 12.5523 3 12 3C11.4477 3 11 3.33579 11 3.75V11H3.75C3.33579 11 3 11.4477 3 12C3 12.5523 3.33579 13 3.75 13H11V20.25C11 20.6642 11.4477 21 12 21C12.5523 21 13 20.6642 13 20.25V13H20.25C20.6642 13 21 12.5523 21 12C21 11.4477 20.6642 11 20.25 11H13V3.75Z"
        fill="currentColor" />
    </svg>
  );
}

export default React.memo(PlusIcon);
